export default __webpack_public_path__ + "f2b12503212721c84d00c1617ce695c4.png";